(ns app.connect-link.register
  "UI register entries for the connect-link slice."
  (:require [app.connect-link.modal :as modal]))

(def register
  [modal/modal])
